import React from 'react'
import { AnimationOnScroll } from 'react-animation-on-scroll'

export default function FacilitySection() {
    return (
        <div className='facility-section d-flex flex-column align-items-start justify-content-center'>
            <AnimationOnScroll duration={2} animateIn="animate__slideInUp">
                <h3 style={{ fontWeight: '800', fontSize: '2em', textAlign: 'start' }}>
                    OUR MANUFACTURING FACILITY
                </h3>
            </AnimationOnScroll>
            <AnimationOnScroll duration={2} animateIn="animate__slideInUp">
                <p align='left' style={{ fontWeight: '500', fontSize: '1.5em' }}>
                    Located in Coimbatore, Tamil Nadu, our fully <br />
                    integrated and industry-leading facility is one<br />
                    amongst the most safe and technologically<br />
                    progressive manufacturing facilities in Southern<br />
                    India.
                </p>
            </AnimationOnScroll>
        </div>
    )
}
